<template>
  <div style="height: 100%">   
    <ExibirErrosConcept :errorsValidacao="errorsValidacao" ref="errosComponent"></ExibirErrosConcept>
    
    <div>
        <vx-card>
            <div class="vx-row mb-4">
                <div class="vx-col md:w-1/2 w-full">                    
                    <vs-button class="ml-auto mt-2" size="small" @click="gravar" color="success" v-if="temPermissaoAlterar">Gravar</vs-button>
                    <vs-button class="ml-4 mt-2" size="small" @click="excluir" v-show="isDeletable && temPermissaoAlterar" color="danger">Excluir</vs-button>            
                    <vs-button class="ml-4 mt-2" size="small" type="border" color="dark" @click="voltar">Voltar</vs-button>             
                </div>
            </div>                       
            <div class="vx-row">        
                <div class="vx-col w-1/2">
                    <label class="vs-input--label">Empresa</label>
                    <v-select          
                        label="razaoSocial"                                                 
                        :options="listaEmpresas"          
                        :disabled="!isConcept"         
                        v-model="data_local.empresa"                             
                    class="v-select w-full"></v-select> 
                </div>      

                <div class="vx-col w-1/2">
                    <label class="vs-input--label">Nome</label>
                    <vs-input class="w-full" v-model="data_local.nome" :maxlength="255"/>   
                </div>                 
            </div>
            <div class="vx-row">        
                <div class="vx-col w-1/2">
                    <label class="vs-input--label">CPF</label>
                    <vs-input class="w-full" v-model="data_local.cpf" :maxlength="14"/>   
                </div>                 
                <div class="vx-col w-1/2">
                    <label class="vs-input--label">Perfil</label>                    
                    <v-select                                               
                        :options="CONTANTES_PERFIL_USUARIO" 
                        v-model="data_local.perfil"    
                        :clearable="false"
                        :reduce="r => r.data"     
                        class="v-select w-full">
                    </v-select>
                </div>                 
            </div>  

            <div class="vx-row">                                             
                <div class="vx-col w-1/2">
                    <label class="vs-input--label">E-mail</label>
                    <vs-input class="w-full" v-model="data_local.email" :maxlength="255"/>   
                </div>                 
                <div class="vx-col w-1/2">
                    <label class="vs-input--label">Senha</label>
                    <vs-input class="w-full" v-model="data_local.senha" type="password" :maxlength="45"/>   
                </div>                 
            </div>                          
        </vx-card>  
    </div>
    
  </div>
</template>

<script>
import axios from "@/axios.js"

const URL_SERVLET = "/Usuario";
const NAME_ROUTE_SEARCH = "cadastro-usuarios-pesquisar";

import { CONTANTES_PERFIL_USUARIO } from '@/constantesComboBox.js'
import { CONTANTES_PERFIL_USUARIO_CONCEPT } from '@/constantesComboBox.js'


export default { 
  props: {
    registroOriginal: {
      type: Object,
      required: false,
      default: function () {
        return { empresa: null, nome: null, cpf: null, email: null, senha: null, perfil: null }
       }
    },
  },
  data() {
    return {        
        errorsValidacao: [],  
        listaEmpresas: [],
        data_local: JSON.parse(JSON.stringify(this.registroOriginal))        
    }
  },  
  created(){
    if (this.isConcept) {
        this.CONTANTES_PERFIL_USUARIO = CONTANTES_PERFIL_USUARIO_CONCEPT;    
    } else  {
        this.CONTANTES_PERFIL_USUARIO = CONTANTES_PERFIL_USUARIO;    
    }
  }, 
  mounted() {
    this.fetchEmpresas();
    if (this.registroOriginal.hasOwnProperty('id')) {
        this.$vs.loading()
        this.findById();  
    } else {
        this.data_local.empresa = this.$store.state.AppActiveUser.empresa;
    }
  },
  computed: {      
    isConcept() {
        return this.$store.state.AppActiveUser.empresa.id === 1;
    },
    isDesabilitarCampo(){
        return this.data_local != null && this.data_local.hasOwnProperty("id");
    }, 
    isDeletable() {
       return this.data_local != null && this.data_local.hasOwnProperty("id");
    }, 
    isGestor() {
      return (this.$store.state.AppActiveUser.perfil === 'GESTOR' || this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA');
    },
    temPermissaoAlterar() {
        if ( this.isGestor ) {
            return true;
        } 

       return false; 
    }
  },
  methods: {  
    fetchEmpresas() {      
      const params = new URLSearchParams();      
      params.append('pagina',  -1);
      
      axios.post("/Empresa/ListarEmpresa", params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {              
            this.listaEmpresas = response.data.Resultado.lista;                 
          }
      })
      .catch((error) => { 
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchListaUnidadeOperacional - " + error); 
      })                
    }, 
    findById() {       
        const params = new URLSearchParams();       
        params.append('id', this.data_local.id);           
                
        axios.post(URL_SERVLET + "/recuperar", params, {              
            headers: {'Accept': 'application/json' }, credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            this.$vs.loading.close()            
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {                
                 this.data_local = response.data.Usuario;                            
            }
        })
        .catch((error) => { 
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - gravar - " + error); 
        })  
    }, 
    excluir() {
        this.$vs.dialog({
          type: 'confirm', color: 'warning', title: 'Atenção', text: 'Deseja excluir ?', acceptText: 'Sim', cancelText: 'Não', accept: this.excluirRequest
        });
    },
    excluirRequest() {
        this.$vs.loading();  
        const params = new URLSearchParams();                        
        params.append('listaIds', this.data_local.id);   
                
        axios.post(URL_SERVLET + "/remover", params, {              
                credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/' });
            } else {
                this.$vs.loading.close();
                if (response.data.hasOwnProperty("error")) {
                        this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data.error, acceptText: 'OK'})
                } else {
                    this.$router.push({ name: NAME_ROUTE_SEARCH })
                }                   
            }
        })
        .catch((error) => { 
            this.$vs.loading.close();
            /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - gravar - " + error); 
        })  
    },
    gravar() {        
        if (this.formularioValido()) { 
            this.$vs.loading();
            const params = new URLSearchParams();    
            
            if (this.data_local.hasOwnProperty('id')) {
                params.append('id', this.data_local.id);    
            }
            
            params.append('empresa.id', this.data_local.empresa.id);            
            params.append('nome', this.data_local.nome);                        
            params.append('cpf', this.data_local.cpf);
            params.append('email', this.data_local.email);
            if (this.data_local.senha) {
                params.append('senha', this.data_local.senha);
            }
            params.append('perfil', this.data_local.perfil);
            
            axios.post(URL_SERVLET + "/gravar", params, {              
                    credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
            .then((response) => {
                
                if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {                    
                    this.$vs.loading.close()
                    this.$router.push({ path: '/' });
                } else {                    
                    if (response.data.Usuario.erroOperacao) {                 
                        this.$vs.loading.close()       
                        this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data.Usuario.mensagemResultadoOperacao, acceptText: 'OK'})
                    } else {                        
                         this.$vs.notify({
                            title: "Mensagem", iconPack: 'feather', icon: 'icon-info', color: 'success',
                            text: response.data.Usuario.mensagemResultadoOperacao,
                        });

                        this.data_local = response.data.Usuario;  
                        this.findById();
                    }                   
                }
            })
            .catch((error) => { 
                this.$vs.loading.close();
                /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - gravar - " + error); 
            })  
        }         
    },
    voltar() {
        this.$router.push({
            name: NAME_ROUTE_SEARCH                     
        })
    },
    formularioValido() {
        this.$refs.errosComponent.iniciar();
        this.errorsValidacao = [];
        
        if (!this.data_local.empresa || !this.data_local.empresa.id) { this.errorsValidacao.push("Empresa obrigatória"); }
        if (!this.data_local.nome) { this.errorsValidacao.push("Nome obrigatório"); }
        if (!this.data_local.cpf) { this.errorsValidacao.push("CPF obrigatório"); }
        if (!this.data_local.email) { this.errorsValidacao.push("Email obrigatório"); }
        if (!this.data_local.hasOwnProperty('id')) {
            //Só valida o preenchimento da senha no INSERT
            if (!this.data_local.senha) { this.errorsValidacao.push("Senha obrigatório"); }
        }
        if (!this.data_local.perfil) { this.errorsValidacao.push("Perfil obrigatório"); }
                      
        if (!this.errorsValidacao.length) {
            return true;
        }   
        return false;
    },    
  }
}
</script>

<style scoped>  
  .vs__dropdown-menu {
    max-height: 80px;    
  }
</style>

<style scoped>
  .tabelaComScroll {      
      overflow: auto;  
      height: calc(100vh - 300px);
      position: relative;      
    } 
</style>